import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 100px;
  width: 100%;
  font-family: 'Light';
  padding: 16px 15px 10px 15px;
  background-color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.text};
  border-top: 1px solid ${({ theme }) => theme.blue[50]};
  z-index: 2;

  & > a {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: center;
    text-decoration: none;
    color: inherit;
  }
`;
